<template>
  <!-- Parent Modal Component -->
  <Modal
    :title="$t('create_sub_category')"
    modalId="create-modal"
    @submit="submitSubCategory"
    @cancel="resetForm"
  >
    <form @submit.prevent="submitSubCategory">
      <!-- Category Select -->
      <div class="mb-3">
        <label class="form-label text-nowrap gap-2">{{ $t('select_category') }} <span class="text-danger">*</span></label>
        <div class="row justify-content-between align-items-center">
          <div class="col-10">
            
            <VueSelect2
              :modelValue="String(sub_category.p_id)"
              :options="formattedCategories"
              :placeholder="$t('select_an_option')"
              class="form-control"
              style="width: 100%;"
              :settings="{
                dropdownParent: '#create-modal',
                allowClear: true,
              }"
              v-model="sub_category.p_id"
            />

            <div v-if="errors.p_id" class="text-danger mt-2">
              <span>{{ errors.p_id }}</span>
            </div>
          </div>

          <!-- Button to Open Child Modal -->
          <div class="col-2">
            <button  type="button" class="col btn btn-primary" @click="openCreateCategoryModal">
              <i class="ti ti-circle-plus fs-4 text-white"></i>
            </button>
          </div> 
        </div>
      </div>

      <!-- Sub Category Name Input -->
      <div class="mb-3">
        <label class="form-label">{{ $t('sub_category_name') }} <span class="text-danger">*</span></label>
        <input
          type="text"
          v-model="sub_category.node"
          class="form-control"
          :placeholder="$t('enter_sub_category_name')"
        />
        <div v-if="errors.node" class="text-danger mt-2">
          <span>{{ errors.node }}</span>
        </div>
      </div>
      <!-- Error Message -->
      <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
    </form>
  </Modal>

  <!-- Child Modal Component -->
  <CreateCategoryModal
    :title="$t('add_new_category')"
    modalId="create-category-modal"
    @category-created="handleCategoryCreated"
    @cancel="handleChildModalCancel"
  />
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import VueSelect2 from 'vue3-select2-component';
import CreateCategoryModal from './CreateCategoryModal.vue'; // Import the child modal
import apiUrls from '../../../urls';
import {useToast} from "vue-toastification";


export default {
  components: {
    Modal,
    VueSelect2,
    CreateCategoryModal, // Register the child modal
  },

  props: {
    categories: Array, // Categories passed from the parent component
  },

  emits: ['create_success'], // Declare the custom event

  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      sub_category: {
        node: '', // Sub category name
        p_id: '', // Parent category ID
      },
      errorMessage: '', // General error message
      errors: {}, // Field-specific errors
    };
  },
  computed: {
    // Format categories for VueSelect2
    formattedCategories() {
      return this.categories.map((category) => ({
        id: category.account_id,
        text: category.node,
      }));
    },
  },
  methods: {
    // Open the child modal
    openCreateCategoryModal() {
      const childModal = new bootstrap.Modal(document.getElementById('create-category-modal'));
      childModal.show();
      document.getElementById('create-modal').classList.add('blur-background');
    },
    // Handle the created category from the child modal
    handleCategoryCreated(createdCategory) {
      this.categories.unshift(createdCategory);
      this.sub_category.p_id = createdCategory.account_id;
      document.getElementById('create-modal').classList.remove('blur-background');
    },
    // Handle child modal cancel event
    handleChildModalCancel() {
      document.getElementById('create-modal').classList.remove('blur-background');
    },
    // Submit the subcategory form
    async submitSubCategory() {
      try {
        const formData = new FormData();

        // Append form data
        Object.keys(this.sub_category).forEach((key) => {
          formData.append(key, this.sub_category[key]);
        });

        // Send API request to create subcategory
        const response = await this.$axios.post(apiUrls.sub_categories.post, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        this.toast.success("Sub category successfully created!");

        // Close the modal after success
        const modal = document.getElementById('create-modal');
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();

        // Emit event to update the parent component
        this.$emit('create_success');

        // Reset the form
        this.resetForm();
      } catch (error) {
        // Handle general error message
        if (error.response?.data?.error) {
          this.errorMessage = error.response.data.error;
        }

        // Handle field-specific errors
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors;
        }
      }
    },
    // Reset the form and errors
    resetForm() {
      this.sub_category.node = '';
      this.sub_category.p_id = '';
      this.errors = {};
      this.errorMessage = '';
    },
  },

  mounted() {
    document.getElementById("create-category-modal").addEventListener("hidden.bs.modal", () => {
      document.getElementById("create-modal").classList.remove("blur-background");
    });
  }
};
</script>

<style scoped>
/* Add custom styles if needed */
</style>